module.exports = __webpack_public_path__ + "onboarding-pkg.cdfcb602004daba267670c48da6cc061.hashedasset.svg";